export default "__VITE_ASSET__21c90b6e__"